import config from '../config/config.json'
import superagent from 'superagent'
import * as c from '../constants/actionTypes';


// Invoice Paid routes
const UPDATE_INVOICEPAID_ARRAY = 'UPDATE_INVOICEPAID_ARRAY'
export {
  UPDATE_INVOICEPAID_ARRAY
}

export function invoicePaidSelect(i){
  return{
    type: UPDATE_INVOICEPAID_ARRAY,
    docid: i
  }
}

const GET_ADMINSUBMISSION_REQUEST = 'GET_ADMINSUBMISSION_REQUEST'
const GET_ADMINSUBMISSION_SUCCESS = 'GET_ADMINSUBMISSION_SUCCESS'
const GET_ADMINSUBMISSION_FAILURE = 'GET_ADMINSUBMISSION_FAILURE'

export {
  GET_ADMINSUBMISSION_REQUEST,
  GET_ADMINSUBMISSION_SUCCESS,
  GET_ADMINSUBMISSION_FAILURE
}

export function getAdminSubmissionRequest() {
  return {
    type: GET_ADMINSUBMISSION_REQUEST,
    loading: true
  }
}

export function getAdminSubmissionSuccess(body, status) {
  return {
    type: GET_ADMINSUBMISSION_SUCCESS,
    body: body,
    status: status,
    loading: false
  }
}

export function getAdminSubmissionFailure(error) {
  return {
    type: GET_ADMINSUBMISSION_FAILURE,
    error: error,
    loading: false
  }
}

// Admin Get invoices
// -----------------------------------------------------------------------------

const GET_ADMININVOICES_REQUEST = 'GET_ADMININVOICES_REQUEST'
const GET_ADMININVOICES_SUCCESS = 'GET_ADMININVOICES_SUCCESS'
const GET_ADMININVOICES_FAILURE = 'GET_ADMININVOICES_FAILURE'

export {
  GET_ADMININVOICES_REQUEST,
  GET_ADMININVOICES_SUCCESS,
  GET_ADMININVOICES_FAILURE
}

export function adminGetInvoicesRequest() {
  return {
    type: GET_ADMININVOICES_REQUEST,
    loading: true
  }
}

export function adminGetInvoicesSuccess(body) {
  return {
    type: GET_ADMININVOICES_SUCCESS,
    body: body,
    loading: false
  }
}

export function adminGetInvoicesFailure(error) {
  return {
    type: GET_ADMININVOICES_FAILURE,
    error: error,
    loading: false
  }
}

// -----------------------------------------------------------------------------

const UPDATE_ADMINSUBMISSION_INPUT = 'UPDATE_ADMINSUBMISSION_INPUT'

export { UPDATE_ADMINSUBMISSION_INPUT }

export function updateAdminSubmissionInput(key, value) {
  return {
    type: UPDATE_ADMINSUBMISSION_INPUT,
    key: key,
    value: value
  }
}

export function getAdminAllDocumentsRequest() {
  return {
    type: c.GET_ADMIN_DOCUMENTS_REQUEST,
    loading: true
  }
}

export function getAdminAllDocumentsSuccess(body) {
  return {
    type: c.GET_ADMIN_DOCUMENTS_SUCCESS,
    body: body,
    loading: false
  }
}

export function getAdminAllDocumentsFailure(error) {
  return {
    type: c.GET_ADMIN_DOCUMENTS_FAILURE,
    error: error,
    loading: false
  }
}

// ---------- START COUPON ACTIONS ---------- //
const GET_COUPONCODES_REQUEST = 'GET_COUPONCODES_REQUEST'
const GET_COUPONCODES_SUCCESS = 'GET_COUPONCODES_SUCCESS'
const GET_COUPONCODES_FAILURE = 'GET_COUPONCODES_FAILURE'

export {
  GET_COUPONCODES_REQUEST,
  GET_COUPONCODES_SUCCESS,
  GET_COUPONCODES_FAILURE
}

export function getCouponCodesRequest() {
  return {
    type: GET_COUPONCODES_REQUEST,
    loading: true
  }
}

export function getCouponCodesSuccess(body) {
  return {
    type: GET_COUPONCODES_SUCCESS,
    body: body,
    loading: false
  }
}

export function getCouponCodesFailure(error) {
  return {
    type: GET_COUPONCODES_FAILURE,
    error: error,
    loading: false
  }
}
export function updateCouponProp(key, value){
  return {
    type: c.UPDATE_COUPON_PROP,
    key: 'new_coupon_'+key,
    value: value
  }
}

export function sendCouponCode(body, cb) {
  return function(dispatch) {
    console.log("Checking coupon code:");
    console.log(body);
    // dispatch(getCouponCodesRequest())
    superagent
    .post(config.BASE + 'api/admin/coupons')
    .send(body)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // dispatch(getCouponCodesFailure(err))
        alert("error: " + res.body.message);
      } else {
        alert("Sucess!");
        // dispatch(getCouponCodesSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

export function getCouponCodes(status, page, cb) {
  return function(dispatch) {
    dispatch(getCouponCodesRequest())
    superagent
    .get(config.BASE + 'api/admin/coupons')
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // alert("Could not retrieve affiliate codes")
        dispatch(getCouponCodesFailure(err))
      } else {
        dispatch(getCouponCodesSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

const DELETE_COUPON_REQUEST = 'DELETE_COUPON_REQUEST'
const DELETE_COUPON_FAILURE = 'DELETE_COUPON_FAILURE'
const DELETE_COUPON_SUCCESS = 'DELETE_COUPON_SUCCESS'

export {
  DELETE_COUPON_REQUEST,
  DELETE_COUPON_SUCCESS,
  DELETE_COUPON_FAILURE
}
export function deleteCouponRequest() {
  return {
    type: DELETE_COUPON_REQUEST,
    loading: true
  }
}

export function deleteCouponFailed() {
  return {
    type: DELETE_COUPON_FAILURE,
    loading: false
  }
}

export function deleteCouponSuccess() {
  return {
    type: DELETE_COUPON_SUCCESS,
    loading: false
  }
}

export function deleteCoupon(code, cb) {
  return function(dispatch) {
    dispatch(deleteCouponRequest())
    superagent.delete(config.BASE + 'api/admin/disablecoupon')
    .send({'coupon_code': code})
    .withCredentials()
    .end((err, res) => {
      if(err) {
        alert("failed deactivating coupon");
        dispatch(deleteCouponFailed())
      } else {
        dispatch(deleteCouponSuccess())
        if(cb) {
          cb(true);
        }
      }
    })
  }
}
// ----------- END COUPON ACTIONS ----------- //

// ----------- START AFFILIATE ACTIONS ----------- //
const GET_AFFILIATES_REQUEST = 'GET_AFFILIATES_REQUEST'
const GET_AFFILIATES_SUCCESS = 'GET_AFFILIATES_SUCCESS'
const GET_AFFILIATES_FAILURE = 'GET_AFFILIATES_FAILURE'

export {
  GET_AFFILIATES_REQUEST,
  GET_AFFILIATES_SUCCESS,
  GET_AFFILIATES_FAILURE
}

export function getAffiliatesRequest() {
  return {
    type: GET_AFFILIATES_REQUEST,
    loading: true
  }
}

export function getAffiliatesSuccess(body) {
  return {
    type: GET_AFFILIATES_SUCCESS,
    body: body,
    loading: false
  }
}

export function getAffiliatesFailure(error) {
  return {
    type: GET_AFFILIATES_FAILURE,
    error: error,
    loading: false
  }
}

export function getAffiliates(status, page, cb) {
  return function(dispatch) {
    dispatch(getAffiliatesRequest())
    superagent
    .get(config.BASE + 'api/admin/affiliates')
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // alert("Could not retrieve affiliate codes")
        dispatch(getAffiliatesFailure(err))
      } else {
        dispatch(getAffiliatesSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}
// --------- END AFFILIATE ACTIONS --------- //
export function getAdminSubmission(status, page, cb) {
  return function(dispatch) {
    dispatch(getAdminSubmissionRequest())
    superagent
    .get(config.BASE + '/api/admin/submissions?status=' + (status || "") + '&page=' + (page || ""))
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // alert("Could not retrieve admin submissions")
        dispatch(getAdminSubmissionFailure(err))
      } else {
        dispatch(getAdminSubmissionSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

export function adminGetDocuments(page, status, cb){
  var queryParams = [];
  if(page) {
    queryParams.push('page='+page);
  }
  if(status && typeof status == 'string') {
    queryParams.push('status='+status)
  } else if (status && typeof status == 'object' && status instanceof Array) {
    for(var i in status) {
      queryParams.push('status[]='+status[i]);
    }
  }
  if(queryParams.length > 0) {
    var params = queryParams.join('&');
  }
  
  return function(dispatch) {
    dispatch(getAdminAllDocumentsRequest())
    superagent
    .get(config.BASE + 'api/admin/submissions?'+params)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // alert("Could not retrieve admin submissions")
        dispatch(getAdminAllDocumentsFailure(err))
      } else {
        dispatch(getAdminSubmissionSuccess(res.body, status))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}


export function adminGetInvoices(status, cb){
  return function(dispatch) {
    dispatch(adminGetInvoicesRequest())
    superagent
    .get(config.BASE + '/api/admin/invoices?status=' + (status || ""))
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // alert("Could not retrieve admin submissions")
        dispatch(adminGetInvoicesFailure(err))
      } else {
        dispatch(adminGetInvoicesSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Admin.js